import React, { Dispatch, SetStateAction } from 'react';
import cn from 'classnames';

import { Tooltip } from '@components/common';

import { useAppDispatch } from '@store/store';

import { setLastUsedTabSection } from '@slices/map';

import styles from './TabSections.module.scss';

export interface ITabSection {
	name: string;
	isActive: boolean;
	component: any;
	id: string;
	isDisabled: boolean;
	props?: any;
	conditionDescription?: string;
}

interface ITabSectionsProps {
	tabs: Array<ITabSection>;
	setTabState: Dispatch<SetStateAction<Array<ITabSection>>>;
}

const TabSections = ({ tabs, setTabState }: ITabSectionsProps) => {
	const dispatch = useAppDispatch();

	const handleTabSwitch = (name: string, isDisabled: boolean) => {
		if (isDisabled) return;

		dispatch(setLastUsedTabSection(name));

		setTabState(() => {
			return tabs.map(tab => {
				if (tab.name === name) return { ...tab, isActive: true };

				return { ...tab, isActive: false };
			});
		});
	};

	return (
		<div className={styles.container}>
			{tabs.map(({
				component: Component,
				conditionDescription,
				id,
				isActive,
				isDisabled,
				name,
				props,
			}) => (
				<React.Fragment key={id}>
					{conditionDescription && isDisabled
						? <Tooltip content={conditionDescription}>
							<div
								className={cn(styles.tabItem, {
									[styles.activeTab]: isActive,
									[styles.disabled]: isDisabled,
								})}
								onClick={() => handleTabSwitch(name, isDisabled)}
							>
								{name}
							</div>
						</Tooltip>
						: <div
							className={cn(styles.tabItem, {
								[styles.activeTab]: isActive,
								[styles.disabled]: isDisabled,
							})}
							onClick={() => handleTabSwitch(name, isDisabled)}
						>
							{name}
						</div>
					}
					{isActive && (
						<div className={styles.content}>
							<Component {...props} />
						</div>
					)}
				</React.Fragment>
			))}
		</div>
	);
};

export default TabSections;
